const ImageBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="#ffd400" d="M1 1h22v22H1z" />
    <path d="M22 2v20H2V2h20m2-2H0v24h24V0z" fill="#333" />
    <path fill="#fff" d="M2 2h20v10H2z" />
    <circle cx="6" cy="6" r="2" fill="#333" />
  </svg>
);

export default ImageBlockIcon;
